import { combineReducers } from '@reduxjs/toolkit'

import authReducer from './partials/auth/authSlice'
import cartReducer from './partials/cart/cartSlice'
import shopReducer from './partials/shop/shopSlice'
import snackbarReducer from './partials/snackbar/snackbarSlice'

const rootReducer = combineReducers({
  auth: authReducer,
  snackbar: snackbarReducer,
  shop: shopReducer,
  cart: cartReducer,
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
